import { useMovementConversationsQuery } from '@shared/generated/graphql';
import { conversationFromFragment } from '@shared/graphql/fromFragments/conversation';
import { Conversation } from '@shared/types/conversation';

export type MovementConversation = Omit<Conversation, 'associatedCarriers'> & {
  associatedCarriers: { id: string; name: string }[];
};

type UseGetMovementConversationsOptions = {
  movementId: string;
  skip?: boolean;
};

type UseGetMovementConversationsState = {
  conversations: MovementConversation[];
  isLoading: boolean;
};

export function useGetMovementConversations({
  movementId,
  skip,
}: UseGetMovementConversationsOptions): UseGetMovementConversationsState {
  const { data, loading } = useMovementConversationsQuery({
    variables: { movementId },
    skip: skip || !movementId,
  });

  const conversations =
    data?.movementById?.conversations?.map((fragment) => ({
      ...conversationFromFragment(fragment),
      associatedCarriers:
        fragment.associatedCarriers?.map((carrier) => ({
          id: carrier.id,
          name: carrier.name,
        })) ?? [],
    })) ?? [];

  return { conversations, isLoading: loading };
}
